module.exports = __webpack_public_path__ + "img/location.032f1d30.svg";